import React from "react";
import ImageAssetViewer from "./ImageAssetViewer";
import MsFileViewer from "./MsFileViewer";
import VideoAssetViewer from "./VideoAssetViewer";
import RenditionViewer from "./RenditionViewer";
import AudioAssetViewer from "./AudioAssetViewer";
import AutodeskViewer from "./AutodeskViewer";

import { isAutodeskAsset } from "../../util";

import "./AssetViewer.css";

import { isRendition, isImage, isVideo, isMsFile, isAudio } from "../../types";
import { DEFAULT_LANGUAGE_CODE } from "../../constants";

export interface IAssetViewer {
  renderPreview(): void;
  render(): void;
}

export interface IAssetViewerProps {
  asset?: Asset | null;
  lng?: string;
}

const DEFAULT_PROPS = {
  asset: null,
  lng: DEFAULT_LANGUAGE_CODE
};

const AssetViewer = (props: IAssetViewerProps = DEFAULT_PROPS) => {
  const { asset } = props;

  if (!asset) {
    return null;
  }

  if (isAutodeskAsset(asset)) {
    return <AutodeskViewer asset={asset} />;
  }

  if (isMsFile(asset)) {
    return <MsFileViewer asset={asset} />;
  }

  if (isRendition(asset)) {
    return <RenditionViewer asset={asset} />;
  }

  if (isVideo(asset)) {
    return <VideoAssetViewer asset={asset} lng={props.lng} />;
  }

  if (isAudio(asset)) {
    return <AudioAssetViewer asset={asset} />;
  }

  if (isImage(asset)) {
    return <ImageAssetViewer asset={asset} />;
  }

  return null;
};

export default AssetViewer;
